// Sharing only needs the URL host rewrite. Importing the complete product-image
// selector here pulled its reviewed exclusion registry into every page that
// renders the sitewide ShareBar.
import { getProxiedStoragePath } from '@/lib/proxied-storage-path'
import { isFridgeFallbackImage } from '@/lib/fridge-fallback-image'

/** Public shares always lead to the canonical Fridge.com page. */
const ORIGIN = 'https://fridge.com'

export function canonicalShareUrl(pageUrl?: string, currentUrl?: string, anchorId?: string): string {
  let source: URL
  try {
    source = new URL(pageUrl || currentUrl || '/', ORIGIN)
  } catch {
    source = new URL('/', ORIGIN)
  }
  const target = new URL(ORIGIN)
  target.pathname = source.pathname
  // Preserve useful page state, but never carry old campaign tracking forward.
  source.searchParams.forEach((value, key) => {
    if (!key.toLowerCase().startsWith('utm_')) target.searchParams.append(key, value)
  })
  target.hash = anchorId ?? source.hash
  return target.toString()
}

export function trackedShareUrl(pageUrl: string, source: string, campaign: string, content?: string): string {
  const target = new URL(pageUrl)
  target.searchParams.set('utm_source', source)
  target.searchParams.set('utm_medium', 'social')
  target.searchParams.set('utm_campaign', campaign)
  if (content?.trim()) target.searchParams.set('utm_content', content)
  return target.toString()
}

export function pinterestShareUrl(pageUrl: string, description: string, imageUrl?: string): string {
  const target = new URL('https://pinterest.com/pin/create/button/')
  target.searchParams.set('url', pageUrl)
  target.searchParams.set('description', description)
  // A missing-photo logo is presentation chrome, not the image being saved.
  if (imageUrl?.trim() && !isFridgeFallbackImage(imageUrl)) {
    try {
      const image = new URL(getProxiedStoragePath(imageUrl), ORIGIN)
      if (image.protocol === 'http:') image.protocol = 'https:'
      if (image.protocol === 'https:' || image.protocol === 'http:') target.searchParams.set('media', image.toString())
    } catch { /* An invalid image must not break sharing the page. */ }
  }
  return target.toString()
}
